import styled from 'styled-components';


export const StyledInfoPanel = styled.div`


`;



// WEBPACK FOOTER //
// ./src/common/InfoPanel/styles/StyledInfoPanel.js